import { String } from 'app/shared/domain/value-objects/string';

export class TranslationId extends String {

}
